module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fathertoson.show),
      expression: "fathertoson.show"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal_dialog"
  }, [_c('div', {
    staticClass: "modal_top"
  }, [_c('p', {
    staticClass: "tip_content"
  }, [_vm._v(_vm._s(_vm.fathertoson.content))])]), _vm._v(" "), ((!_vm.fathertoson.cancelText) && _vm.fathertoson.okText != '确定') ? _c('div', {
    staticClass: "modal_bottom"
  }, [_c('div', {
    staticClass: "tip_button",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.fathertoson.okText))])]) : _vm._e(), _vm._v(" "), (_vm.fathertoson.okText == '确定') ? _c('div', {
    staticClass: "modal_bottom"
  }, [_c('div', {
    staticClass: "tip_button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.fathertoson.okText))])]) : _vm._e(), _vm._v(" "), (_vm.fathertoson.cancelText) ? _c('div', {
    staticClass: "modal_bottom cancel"
  }, [_c('div', {
    staticClass: "tip_button exit",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.fathertoson.cancelText))]), _vm._v(" "), _c('div', {
    staticClass: "tip_button sure",
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v(_vm._s(_vm.fathertoson.okText))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-fe593aec"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 516
// module chunks = 10